import { useCallback, useEffect, useState } from "react";

import { getWebFilterStatus, installWebFilter } from "@/lib/native/webFilter";
import type { WebFilterStatus } from "@/lib/native/plugins";
import {
  isNativeWebFilterVpnPlatform,
  requiresVpnForTypedWebEditing,
} from "@/lib/native/webFilterVpnGate";

const UNTRACKED_STATUS: WebFilterStatus = {
  status: "unavailable",
  installed: false,
  enabled: false,
  enforcedCount: 0,
};

export function useWebFilterVpnGate(active: boolean) {
  const [status, setStatus] = useState<WebFilterStatus>(UNTRACKED_STATUS);

  const needsVpn = isNativeWebFilterVpnPlatform() && requiresVpnForTypedWebEditing(status);

  const refreshStatus = useCallback(async () => {
    if (!isNativeWebFilterVpnPlatform()) {
      setStatus(UNTRACKED_STATUS);
      return UNTRACKED_STATUS;
    }
    const next = await getWebFilterStatus();
    setStatus(next);
    return next;
  }, []);

  useEffect(() => {
    if (!active) return;
    void refreshStatus();
  }, [active, refreshStatus]);

  return {
    needsVpn,
    refreshStatus,
    installVpn: installWebFilter,
  };
}
